export class Hosts {
    public id: string;
    public name: string;
    public ip: string;
    public availability: string;
    public createdAt: string;
    public updatedAt: string;
}